import {Capacitor} from '@capacitor/core';
import {Device} from '@capacitor/device';
import {v4 as uuidv4} from 'uuid';

export const WEB_DEVICE_UUID_KEY = 'device_uuid';

/**
 * The single device identity for FCM register + logout deregister.
 *
 * Native registers push tokens with the Capacitor Device id, but web registers
 * with a self-generated uuid persisted in localStorage — and Capacitor's *web*
 * Device.getId() returns a third, unrelated value. Logout must send the same
 * uuid the platform registered with, or the API can never match the token row.
 */
export const getDeviceUuid = async (): Promise<string> => {
    if (Capacitor.isNativePlatform()) {
        const deviceId = await Device.getId();
        return deviceId.identifier;
    }
    const storedUuid = localStorage.getItem(WEB_DEVICE_UUID_KEY);
    if (storedUuid) {
        return storedUuid;
    }
    const newUuid = uuidv4();
    localStorage.setItem(WEB_DEVICE_UUID_KEY, newUuid);
    return newUuid;
};
